import React from 'react';
import './main.css';
import eiffletower from '../../Assests/eiffletower.jpg';
import tajmahal from '../../Assests/tajmahal.jpeg';
import greatwallofchina from '../../Assests/greatwallofchina.jpg';
import images from '../../Assests/images.jpg';
import colosum from '../../Assests/colosum.jpg';
import mount from '../../Assests/mount.webp'
import opera from '../../Assests/opera.jpg';
import redfort from '../../Assests/redfort.jpg';
import san from '../../Assests/san.jpg';
import machu from '../../Assests/machu.jpg';
import wat from '../../Assests/wat.jpg';
import nigara from '../../Assests/nigara.jpg';

const destinations = [
  {
    name: 'Eiffel Tower',
    location: 'Paris, France',
    image: eiffletower,
    details: 'The Eiffel Tower is one of the most iconic landmarks in the world. It offers breathtaking views of Paris and is a must-visit for tourists.',
    package: '₹50,000 - ₹70,000',
  },
  {
    name: 'Great Wall of China',
    location: 'China',
    image: greatwallofchina,
    details: 'The Great Wall of China is an ancient series of walls and fortifications, stretching over 13,000 miles, offering stunning historical and scenic views.',
    package: '₹60,000 - ₹80,000',
  },
  {
    name: 'Taj Mahal',
    location: 'Agra, India',
    image: tajmahal,
    details: 'The Taj Mahal is a UNESCO World Heritage Site and a symbol of love. It is known for its stunning white marble architecture.',
    package: '₹20,000 - ₹30,000',
  },
  {
    name: 'Statue of Liberty',
    location: 'New York, USA',
    image: images,
    details: 'The Statue of Liberty is a symbol of freedom and democracy. Located on Liberty Island, it offers spectacular views of New York Harbor.',
    package: '₹80,000 - ₹1,00,000',
  },
  {
    name: 'Colosseum',
    location: 'Rome, Italy',
    image: colosum,
    details: 'The Colosseum in Rome is an ancient amphitheater and one of the greatest works of Roman engineering, attracting millions of history enthusiasts each year.',
    package: '₹45,000 - ₹65,000',
  },
  {
    name: 'Mount Everest',
    location: 'Nepal/Tibet Border',
    image: mount,
    details: 'Mount Everest is the highest peak in the world, challenging trekkers and mountaineers. The stunning view from the top is unparalleled.',
    package: '₹90,000 - ₹1,20,000',
  },
  {
    name: 'Sydney Opera House',
    location: 'Sydney, Australia',
    image: opera,
    details: 'The Sydney Opera House is an architectural marvel and one of the most recognizable landmarks in Australia, known for its stunning performances.',
    package: '₹25,000 - ₹45,000',
  },
  {
    name: 'Red Fort',
    location: 'Delhi, India',
    image: redfort,
    details: 'The Red Fort is a UNESCO World Heritage site and a symbol of India\'s rich history, offering insight into Mughal architecture and India\'s past.',
    package: '₹10,000 - ₹20,000',
  },
  {
    name: 'Santorini',
    location: 'Greece',
    image: san,
    details: 'Santorini is a beautiful Greek island known for its stunning sunsets, whitewashed houses, and crystal-clear waters.',
    package: '₹55,000 - ₹75,000',
  },
  {
    name: 'Machu Picchu',
    location: 'Peru',
    image: machu,
    details: 'Machu Picchu is a 15th-century Inca citadel located in the Andes. Its breathtaking location and rich history make it one of the most important archaeological sites in the world.',
    package: '₹60,000 - ₹85,000',
  },
  {
    name: 'Angkor Wat',
    location: 'Siem Reap, Cambodia',
    image: wat,
    details: 'Angkor Wat is the largest religious monument in the world. Known for its stunning architecture and intricate carvings, it is a UNESCO World Heritage site and one of the most famous temples in Southeast Asia.',
    package: '₹55,000 - ₹80,000',
  },
  {
    name: 'Niagara Falls',
    location: 'Ontario, Canada / New York, USA',
    image: nigara,
    details: 'Niagara Falls is a world-famous waterfall that straddles the border between Canada and the USA. Its breathtaking beauty and the roar of the falls attract millions of visitors annually.',
    package: '₹45,000 - ₹70,000',
  }
  
  
];

const Main = () => {
  return (
    <section className="main container section">
      <div className="secTitle">
        <h3 className="title">Most Visited Destinations</h3>
      </div>
      <div className="secContent grid">
        {destinations.map((destination, index) => (
          <div className="destinationCard" key={index}>
            <img src={destination.image} alt={destination.name} className="destinationImage" />
            <div className="destinationInfo">
              <h4>{destination.name}</h4>
              <p>{destination.location}</p>
              <p className="details">{destination.details}</p>
              <p className="package">Package: {destination.package}</p>
              <button className="detailsButton">Details</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Main;
